import { CCallout } from '@coreui/react-pro'
import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setActiveSection } from 'src/redux/progressNote/progressNoteSlice'
import SectionItem from './SectionItem'
import PointClickCareDataCopy from './PointClickCareDataCopy'

export default function DynamicTemplates({
  section,
  onTemplateFill,
  onDataChange,
  setIsTyping,
  noTitle,
  patient,
}) {
  const selectedTemplate = useSelector((state) => state?.progressNote?.selectedTemplate)
  const dispatch = useDispatch()

  let wholeData = selectedTemplate.data

  const index = wholeData?.findIndex((item) => item.title === section?.title)

  return (
    <div className="filter-section-holder">
      {patient?.pointclickcare?.orgUuid && <PointClickCareDataCopy patient={patient} />}
      <div className="title-head">
        {!noTitle && (
          <div className="title">
            {section.title}
            {section.title === 'MIPS' ? ` (${section?.sections?.length})` : ''}
          </div>
        )}
      </div>

      <div className="section-item-holder">
        {section.title === 'MIPS' && section?.sections?.length < 1 && (
          <p>There are no applicable measures for this encounter</p>
        )}
        {section?.instructions && (
          <div className="mx-4">
            <CCallout color="warning">
              <p dangerouslySetInnerHTML={{ __html: section?.instructions }} />
            </CCallout>
          </div>
        )}
        {section?.sections.map((item, i) => (
          <SectionItem
            key={i}
            section={item}
            onTemplateFill={onTemplateFill}
            sectionTitle={section?.title}
            index={i}
            inputDataOnChange={(dataVal) => {
              if (wholeData) {
                let tempData = [...wholeData]
                tempData[index] = { ...section, sections: dataVal }
                dispatch(setActiveSection({ ...section, sections: dataVal }))
                onDataChange(tempData)
              }
            }}
            wholeSection={section}
            noTitle={noTitle}
            isMIPS={section.title === 'MIPS'}
            setIsTyping={setIsTyping}
          />
        ))}
      </div>
    </div>
  )
}
